import { render, staticRenderFns } from "./BDropdown.vue?vue&type=template&id=1a5010e6&"
import script from "./BDropdown.vue?vue&type=script&lang=js&"
export * from "./BDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports